/*
 * ANIME CRUSH — HERO CAROUSEL
 *
 * Only runs where a hero has more than one verified slide. One slide stays one
 * image; the controls are not rendered and this file does nothing.
 *
 * WHAT IT GUARANTEES
 *   - no layout shift: every slide is absolutely positioned inside a box whose
 *     height is already fixed by the hero, so advancing cannot move the page
 *   - a crossfade, not a slide transform. Transforms on a full-bleed image are
 *     where the "images jump" complaint usually comes from
 *   - the first slide is eager, the rest load lazily. A five-slide hero must
 *     not cost five images before anything is visible
 *   - auto-advance pauses on hover, on focus, when the tab is hidden, and when
 *     the visitor has asked for reduced motion it never starts
 *   - swipe on touch, arrow keys when the carousel has focus
 */
(function () {
  'use strict';

  var INTERVAL = 6000;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ac-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ac-dot]'));
    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) index = 0;
    var timer = null;
    var paused = false;

    function show(next) {
      next = (next + slides.length) % slides.length;
      if (next === index) return;

      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      slides[next].classList.add('is-active');
      slides[next].removeAttribute('aria-hidden');

      /* The image for a slide the visitor is about to see is worth loading
       * now; the ones beyond it are not. */
      var img = slides[next].querySelector('img[data-src]');
      if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
      var after = slides[(next + 1) % slides.length].querySelector('img[data-src]');
      if (after) { after.src = after.getAttribute('data-src'); after.removeAttribute('data-src'); }

      if (dots[index]) { dots[index].classList.remove('is-active'); dots[index].removeAttribute('aria-current'); }
      if (dots[next]) { dots[next].classList.add('is-active'); dots[next].setAttribute('aria-current', 'true'); }

      index = next;
    }

    function start() {
      if (reduced || timer) return;
      timer = window.setInterval(function () { if (!paused) show(index + 1); }, INTERVAL);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });

    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-ac-prev]');
      var next = e.target.closest('[data-ac-next]');
      var dot = e.target.closest('[data-ac-dot]');
      if (prev) { e.preventDefault(); show(index - 1); }
      else if (next) { e.preventDefault(); show(index + 1); }
      else if (dot) { e.preventDefault(); show(dots.indexOf(dot)); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    /* Touch: a horizontal drag of more than 40px moves one slide. Vertical
     * drags are left alone so the page still scrolls normally. */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      x0 = null; y0 = null;
    }, { passive: true });

    start();
  }

  /* The homepage carousels (data-ac-carousel="rail" / "fade") belong to
   * assets/ac-carousel.js. Taking them here as well ran two controllers on one
   * Recommends band, each with its own index, and left two slides showing at
   * once (owner screenshot 2026-11-03, Angel's Egg over Naruto). */
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ac-carousel]:not([data-ac-carousel="rail"]):not([data-ac-carousel="fade"])'), setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
